// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { throwIfEnvelopeError } from '@/api/envelope-guard';
import axios from 'axios';

/**
 * Main Axios instance for API requests
 */
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
});

// Surface envelope-level errors on heartbeat-committed 200 responses (see envelope-guard)
api.interceptors.response.use(throwIfEnvelopeError);
